module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-intro-card1.2@2x.1eb23759.jpg";